"use strict";

import http from "@/http";

const BASE_NAME = "/holidays";

const list = async () => {
  const response = await http.get(BASE_NAME);
  return response.data;
};

const create = async ({ date, name }) => {
  const response = await http.post(BASE_NAME, { date, name });
  return response.data;
};

const remove = async id => {
  await http.delete(`${BASE_NAME}/${id}`);
};

export default { list, create, remove };
